module.exports = __webpack_public_path__ + "img/travelService-router.84137a38.jpg";